/* ============================================================================
   Componentes utilitários recorrentes.
   ============================================================================ */

export function Loading() {
  return <div className="mg-loading"><div className="mg-spinner" /></div>;
}

export function EmptyState({ icon, title, children, action }) {
  return (
    <div className="mg-empty">
      {icon && <div className="mg-empty-icon">{icon}</div>}
      {title && <h3>{title}</h3>}
      {children && <p>{children}</p>}
      {action}
    </div>
  );
}

/* Badge de plano colorida a partir da cor do plano (ou verde p/ gratuito) */
export function PlanBadge({ label, color, free }) {
  if (free) return <span className="mg-badge mg-badge-free">{label || 'Gratuito'}</span>;
  const c = color || '#d17d34';
  return (
    <span
      className="mg-badge"
      style={{ background: `${c}1f`, color: c, borderColor: `${c}55` }}
    >
      {label}
    </span>
  );
}
